import React from "react";

import BenefitCreateForm from "components/BenefitManagementComponents/BenefitCreateForm/BenefitCreateForm";

const BenefitCreateRoute: React.FC = () => {

  return (<BenefitCreateForm />)
};

export default BenefitCreateRoute;